// extracted by mini-css-extract-plugin
module.exports = {"faqMainWrapper":"_2zB4H"};